import React from 'react';
import PropTypes from 'prop-types';
import { DataTable } from '@contently/toolkit';
import defaultColumns from './tableConfig';

function TableWrapper({ tableInfo }) {
  const emptyTableInfo = tableInfo.length < 1;

  const createTableData = () => {
    if (emptyTableInfo) {
      tableInfo.push({
        title: 'Title',
        pillar: 'Pillar',
        totalContentDebit: '$0',
        totalOrganicSearchTraffic: 0,
        totalOrganicSearchTrafficValue: '$0'
      });
    }
    return tableInfo;
  };

  return (
    <DataTable.Table
      data={createTableData()}
      columns={defaultColumns}
      pageSize={4}
      showTotal={false}
    />
  );
}

export default TableWrapper;

TableWrapper.propTypes = {
  tableInfo: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      pillar: PropTypes.string,
      totalContentDebit: PropTypes.string,
      totalOrganicSearchTraffic: PropTypes.number,
      totalOrganicSearchTrafficValue: PropTypes.string
    })
  ).isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/table_wrapper.jsx